// The turn clock. A player who has not done anything for IDLE_TURN_MS is skipped, and a
// turn with nothing left to play ends after STUCK_TURN_MS instead of waiting for someone
// to find Avsluta tur. Every play restarts the count.
//
// Each device counts from the moment it saw the turn's latest action rather than from a
// timestamp in the state: clocks on a table of phones do not agree, and a phone that is
// a few seconds fast would otherwise skip somebody early.

export const IDLE_TURN_MS = 30000;
export const STUCK_TURN_MS = 10000;
// The host screen is only the backup for a phone that went quiet. It sees each action a
// poll later than the phone that made it, and waits this much longer on top, so a phone
// that is still there always ends its own turn first.
export const HOST_GRACE_MS = 3000;

export function turnDeadline(seenAt, stuck) {
  return seenAt + (stuck ? STUCK_TURN_MS : IDLE_TURN_MS);
}

export function secondsLeft(deadline, now) {
  return Math.max(0, Math.ceil((deadline - now) / 1000));
}

export function turnClockLabel({seconds, stuck, mine, name}) {
  if (mine) return stuck ? `Inget mer att spela · slut om ${seconds} s` : `${seconds} s kvar av din tur`;
  return stuck ? `${name} är klar · ${seconds} s` : `${name}: ${seconds} s kvar`;
}
